import { useState, useEffect, useRef, useContext } from 'react';
import throttle from 'lodash/throttle';

import Header from './components/Header';
import Game from './components/Game';
import HowToPlayModal from './components/Modals/HowToPlayModal';
import DevModal from './components/Modals/DevModal';
import AboutModal from './components/Modals/AboutModal';
import StatsModal from './components/Modals/StatsModal';

import { ModalContext } from './context/Modal';

import { getGameNumber, getWordOfTheDay } from './lib/dictionary';

import './styles/main.scss';
const App = () => {
  const { currentModal } = useContext(ModalContext);
  const howToPlayModalRef = useRef();
  const devModalRef = useRef();
  const aboutModalRef = useRef();
  const statsModalRef = useRef();
  const [gameNumber, setGameNumber] = useState(null);
  const [solution, setSolution] = useState(null);
  const [shareableResult, setShareableResult] = useState('');
  const [isGameOver, setIsGameOver] = useState(false);
  const [isSmScreen, setIsSmScreen] = useState(false);
  const [gameMinHeight, setGameMinHeight] = useState(0);

  useEffect(() => {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      const updateAppHeight = throttle(() => {
        const siteMainContainer = document.querySelector('.mainContainer');

        if (!siteMainContainer) {
          setGameMinHeight(window.innerHeight);
          return;
        }
        
        const siteMainContainerStyles = window.getComputedStyle(siteMainContainer);
        const siteMainContainerHeight = siteMainContainerStyles.getPropertyValue('height');
        const siteMainContainerPaddingTop = siteMainContainerStyles.getPropertyValue('padding-top') || 0;
        const siteMainContainerPaddingBottom = siteMainContainerStyles.getPropertyValue('padding-bottom') || 0;

        if (siteMainContainerHeight) {
          setGameMinHeight(siteMainContainerHeight - siteMainContainerPaddingTop - siteMainContainerPaddingBottom);
        }
      }, 100);

      setIsSmScreen(window.innerHeight < 700);
      window.addEventListener('resize', updateAppHeight);
      updateAppHeight();

      return () => window.removeEventListener('resize', updateAppHeight);
    }
  }, []);

  useEffect(() => {
    const gameNum = getGameNumber(Date.now());
    setGameNumber(gameNum);

    const updateSolution = async (wordIndex) => {
      const data = await getWordOfTheDay(wordIndex);
      setSolution(data);
    };

    updateSolution(gameNum);
  }, []);

  useEffect(() => {
    const removeKbNavClass = () => document.body.classList.remove('is-kb-nav');
    const keyboardNavigationHandler = e => {
      if (e?.key === 'Tab') {
        document.body.classList.add('is-kb-nav');
      }
    };

    window.addEventListener('touchstart', removeKbNavClass);
    window.addEventListener('click', removeKbNavClass);
    window.addEventListener('keydown', keyboardNavigationHandler);

    return () => {
      window.removeEventListener('touchstart', removeKbNavClass);
      window.removeEventListener('click', removeKbNavClass);
      window.removeEventListener('keydown', keyboardNavigationHandler);
    };
  });

  return (
    <>
      {
        gameNumber && solution &&
        <div style={{ '--height-game': `calc(${gameMinHeight}px - 3rem)` }}>
          <Header
            howToPlayModalRef={howToPlayModalRef}
            devModalRef={devModalRef}
            aboutModalRef={aboutModalRef}
            statsModalRef={statsModalRef}/>
          <Game
            solution={solution.word.toLowerCase()}
            gameNumber={gameNumber}
            statsModalRef={statsModalRef}
            setShareableResult={setShareableResult}
            setIsGameOver={setIsGameOver}
            isSmScreen={isSmScreen}/>
          <HowToPlayModal
            modalRef={howToPlayModalRef}/>
          <DevModal
            modalRef={devModalRef}/>
          <AboutModal
            modalRef={aboutModalRef}/>
          <StatsModal
            modalRef={statsModalRef}
            isOpen={currentModal === 'stats-modal'}
            shareableResult={shareableResult}
            isGameOver={isGameOver}
            solution={solution} />
        </div>
      }
    </>
  );
};

export default App;
